import { render, staticRenderFns } from "./ui-input-details.vue?vue&type=template&id=474679f9&"
import script from "./ui-input-details.vue?vue&type=script&lang=ts&"
export * from "./ui-input-details.vue?vue&type=script&lang=ts&"
import style0 from "./ui-input-details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports